import axios from 'axios';

axios.interceptors.request.use(config => {
  if (typeof window === 'undefined') {
    return config;
  }

  const token = window.localStorage.getItem('token');

  if (token) {
    config.headers.Authorization = `bearer ${token}`;
  }

  return config;
});

const citizenService = {

    getEncaminhamentoCidadao(idEncaminhamento,idFormulario){
        return new Promise((resolve, reject) => {
            axios.get('api/encaminhamento/'+idEncaminhamento+'/'+idFormulario+'?random=' + Math.random())
                  .then(response => {
                    resolve(response);
                 })
                  .catch(response => {
                    reject(response);
                 });
             });
    },

    save(data){
      return new Promise((resolve, reject) => {
        axios
          .post('api/deleteEncaminhamentoCidadao', data)
          .then(response => {
            resolve(response.data);
          })
          .catch(response => {
            reject(response.status);
          });
      });
    }

};

export default citizenService;